<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <ul class="sidebar-menu overflow-auto" v-bind:style="{ height: leftnaveHeight + 'px' }">
        <li class="header">Navigation Menu</li>
        <menu-item v-for="(item) in menuItem" :key="item.id" v-bind:item="item"></menu-item>
      </ul>
    </section>
  </aside>
</template>
<script>
import menuitem from "./MenuItem";
export default {
  components: {
    "menu-item": menuitem
  },
  data: function() {
    return {
      open: false,
      leftnaveHeight: 400
    };
  },
  methods: {
    async getDataOnload() {
      await this.$store.dispatch("loadMenu");
    },
    toggle() {
      this.open = !this.open;
    },
    handleResize: function() {
      this.leftnaveHeight = window.innerHeight - 60;
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  created: function() {
    this.getDataOnload();
  },
  computed: {
    isShow() {
      return this.open ? "show" : "hide";
    },
    menuItem() {
      return this.$store.state.menuItem;
    }
  }
};
</script>
